<template>
  <div class="login-form login-reset">
    <form
        class="form"
        novalidate="novalidate"
        id="kt_login_reset_form"
    >
      <div class="pb-13 pt-lg-0 pt-5">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
          {{ $t('login.reset') }}
        </h3>
        <p class="text-muted font-weight-bold font-size-h4">
          {{ $t('login.resetText') }}
        </p>
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="password"
            :placeholder="$t('login.password')"
            name="password"
            ref="rpassword"
            autocomplete="off"
            v-model="form.password"
        />
      </div>
      <div class="form-group">
        <input
            class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
            type="password"
            :placeholder="$t('login.passwordConfirm')"
            name="cpassword"
            ref="cpassword"
            autocomplete="off"
            v-model="form.passwordRepeat"
        />
      </div>
      <div class="form-group d-flex flex-wrap pb-lg-0">
        <button
            type="submit"
            id="kt_login_reset_submit"
            ref="kt_login_reset_submit"
            class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
        >
          {{ $t('common.submit') }}
        </button>
        <button
            type="button"
            id="kt_login_reset_cancel"
            class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
            @click="$emit('showForm', 'signin1')"
        >
          {{ $t('common.cancel') }}
        </button>

      </div>
    </form>
  </div>
</template>

<script>
import Api from "../../core/services/api.service";
import KTUtil from "@/assets/js/components/util";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import Swal from "sweetalert2";

export default {
  name: "resetForm",
  data() {
    return {
      token: null,
      form: {
        password: "",
        passwordRepeat: "",
      },
    }
  },
  mounted() {
    const reset_form = KTUtil.getById("kt_login_reset_form");
    this.token = this.$route.query.token;

    this.fv = formValidation(reset_form, {
      fields: {
        password: {
          validators: {
            notEmpty: {
              message: this.$i18n.t('login.passwordRequired'),
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: this.$i18n.t('login.confirmPasswordRequired'),
            },
            identical: {
              compare: function () {
                return reset_form.querySelector('[name="password"]').value;
              },
              message: this.$i18n.t('login.passwordsDoesntMath'),
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv.on("core.form.valid", () => {
      const password = this.form.password;

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_reset_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      Api.post(`/forgot_password/${this.token}`, { password: password })
          .then(() => {
            this.$router.push({ name: "tableauDeBord" });
            this.$emit('showForm', 'signin1')
          })
          .catch((error) => {
            let errorMsg = '';
            switch (error.response.status) {
              case 404:
                errorMsg = this.$i18n.t('login.tokenIncorrect');
                break;
                default:
                  errorMsg = this.$i18n.t('common.errorOccurred');
            }
            Swal.fire({
              title: "",
              text: errorMsg,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          })
          .finally(() => {
            submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
            );
          });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: this.$i18n.t('login.incorrectData'),
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });
  },
}
</script>
